
import { useState } from 'react';
import { PerkRating } from '@/lib/types';

export interface ReviewFormData {
  company: string;
  jobTitle: string;
  reasonForExit: string;
  biggestProblem?: string;
  location: string;
  exitDate?: Date;
  fairWorkInvolved?: boolean;
  positiveExperience?: boolean;
  jobCategory?: string;
  tenure?: string;
  perkRatings?: PerkRating[];
  salary?: number; // Added salary field
}

const useReviewForm = (initialCompany = '') => {
  const [formData, setFormData] = useState<ReviewFormData>({
    company: initialCompany,
    jobTitle: '',
    reasonForExit: '',
    biggestProblem: '',
    location: '',
    tenure: '',
    salary: undefined, // Initialize salary as undefined
  });

  const [charCounts, setCharCounts] = useState({
    reasonForExit: 0,
    biggestProblem: 0,
  });

  const handleTextChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));

    // Update character counts for text areas
    if (name === 'reasonForExit' || name === 'biggestProblem') {
      setCharCounts(prev => ({ ...prev, [name]: value.length }));
    }
  };

  const handleDateChange = (date: Date | undefined) => {
    setFormData(prev => ({ ...prev, exitDate: date }));
  };

  const handleRadioChange = (field: string, value: boolean) => {
    setFormData(prev => ({ ...prev, [field]: value }));
  };

  const handleCategoryChange = (value: string) => {
    setFormData(prev => ({ ...prev, jobCategory: value }));
  };

  const handleTenureChange = (value: string) => {
    setFormData(prev => ({ ...prev, tenure: value }));
  };

  const handleLocationChange = (value: string) => {
    setFormData(prev => ({ ...prev, location: value }));
  };

  const handlePerkRatingsChange = (perkRatings: PerkRating[]) => {
    setFormData(prev => ({ ...prev, perkRatings }));
  };
  
  // Add salary handler
  const handleSalaryChange = (value: number | undefined) => {
    setFormData(prev => ({ ...prev, salary: value }));
  };

  return {
    formData,
    charCounts,
    handleTextChange,
    handleDateChange,
    handleRadioChange,
    handleCategoryChange,
    handleTenureChange,
    handleLocationChange,
    handlePerkRatingsChange,
    handleSalaryChange, // Export the new salary handler
    setFormData,
  };
};

export default useReviewForm;
